/* Route definitions for the AQ app.
 *
 * Per saas-greenfield-pitfalls §3: redirects use react-router's Navigate
 * declarative component (or the redirect-throwing loaders pattern when we
 * migrate to data routers). NEVER useEffect + navigate from inside loaders
 * — that lets the protected layout render+flicker first.
 *
 * Current routes (Phase 3.1 shell):
 *   /login           — sign-in form
 *   /                — dashboard (overview)
 *   /devices         — fleet list
 *   /devices/:id     — device detail
 *   /alerts          — alerts list
 *
 * All non-public routes are wrapped in <RouteGuard> + <Layout>. KAIOT-specific
 * routes (ahu, compliance, kiosk, fdd, ...) are deferred to Phase 3.2 per
 * Phase-2 port plan. */

import { Routes, Route, Navigate } from 'react-router-dom';
import { RouteGuard } from '../components/RouteGuard';
import { Layout } from '../components/Layout';
import { LoginPage } from './login';
import { DashboardPage } from './dashboard';
import { DevicesPage } from './devices';
import { DeviceDetailPage } from './device-detail';
import { AlertsPage } from './alerts';

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Authenticated routes — gated by RouteGuard, rendered inside Layout */}
      <Route
        element={
          <RouteGuard>
            <Layout />
          </RouteGuard>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/devices/:deviceId" element={<DeviceDetailPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
